import * as React from "react";
const SvgCheckmarkIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 13, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 6.714L5.2 11 15 1", stroke: "#38A157", strokeWidth: 1.8, fill: "none", strokeLinecap: "round" }));
export { SvgCheckmarkIcon as ReactComponent };
